// Syncs a product card's title link, image link and quick-buy target when a
// color-sibling swatch (a separate product, not a real variant) is selected.
// Impact's native <product-card> element already swaps the image via
// data-variant-media on the same "change" event; this only covers what the
// native code cannot know about (a different product's url/title/variant).
document.addEventListener('change', (event) => {
  const target = event.target;

  if (!target.matches('.product-card__swatch-list input[data-sibling-url]')) {
    return;
  }

  const card = target.closest('product-card');
  if (!card) return;

  const url = target.getAttribute('data-sibling-url');
  const title = target.getAttribute('data-sibling-title');
  const variantId = target.getAttribute('data-sibling-variant-id');
  const handle = url ? url.split('/products/')[1]?.split('?')[0].split('#')[0] : null;

  card.querySelectorAll('.product-card__figure a, .product-card__title a').forEach((link) => {
    link.href = url;
  });

  const titleLink = card.querySelector('.product-card__title a');
  if (titleLink && title) {
    titleLink.textContent = title;
  }

  if (handle) {
    card.setAttribute('handle', handle);
  }

  const quickBuyDrawer = card.querySelector('quick-buy-drawer');
  if (quickBuyDrawer && handle && variantId) {
    quickBuyDrawer.setAttribute('handle', `${handle}?variant=${variantId}`);
  }

  const hiddenIdInput = card.querySelector('.product-card__quick-buy input[name="id"]');
  if (hiddenIdInput && variantId) {
    hiddenIdInput.value = variantId;
  }
});
